module.exports = __webpack_public_path__ + "themify.9c8e96ecc7fa01e6ebcd.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/themify.svg
// module id = ../../../../../src/assets/fonts/themify.svg
// module chunks = styles